export default __webpack_public_path__ + "assets/partly-cloudy-day-drizzle.98fb4238.svg";